import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppResponse, AuthUser } from '../Entities';
import { MenuService } from './menu.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  show_modal_login = false;
  loading = false;
  private _authUser?: AuthUser = new AuthUser();

  constructor(private http: HttpClient, private menuService: MenuService) { }

  login(
    user_name: string,
    password: string
  ): Observable<AppResponse<AuthUser>> {
    return this.http
      .post<AppResponse<AuthUser>>(`${environment.url_auth}`, {
        user_name,
        password,
      })
      .pipe(
        map(resp => {
          this._authUser = resp.data;
          localStorage.setItem('authUser', JSON.stringify(this._authUser));
          this.setMenu();

          if (this.authUser.proveedores != null && this.authUser.proveedores.length > 0 && this.authUser.proveedores.some(s => s.es_repse == true)) {

            //Validamos si tiene bloqueo repse
            if (this.authUser.proveedores.some(s => s.bloqueo_repse == true)) {

              localStorage.setItem('BLOQUEO-REPSE', '1');
            }

            //Validamos si tiene bloqueo repse inicial
            if (this.authUser.proveedores.some(s => s.bloqueo_repse_inicial == true)) {

              localStorage.setItem('BLOQUEO-REPSE-INICIAL', '1');
            }

            //Validamos si tiene Nuevas solicitudes Repse
            if (this.authUser.proveedores.some(s => s.tieneRepseNuevo == true)) {

              localStorage.setItem('NUEVA-SOL-REPSE', '1');
            }

            //Validamos si tiene Nuevas solicitudes Repse Inicial
            if (this.authUser.proveedores.some(s => s.tieneRepseNuevoInicial == true)) {

              localStorage.setItem('NUEVA-SOL-REPSE-INICIAL', '1');
            }

            //Validamos si tiene Nuevas solicitudes Repse concatenadas
            if (this.authUser.proveedores.some(s => s.periodosPendientes != null && s.periodosPendientes != '')) {

              let valores = this.authUser.proveedores.filter(s => s.periodosPendientes != null && s.periodosPendientes != '');

              localStorage.setItem('NUEVA-SOL-REPSE-PERIODOS', valores[0].periodosPendientes!);
            }

            this.forceReload();
          }

          return resp;
        })
      );
  }

  showModalLogin() {
    this.show_modal_login = true;
  }
  hiddeModalLogin() {
    this.show_modal_login = false;
  }

  public get authUser(): AuthUser {
    if (this._authUser && this._authUser.identificador) {
      return this._authUser;
    }
    this._authUser = <AuthUser>JSON.parse(localStorage.getItem('authUser')!);
    this.setMenu();
    return this._authUser;
  }

  public set authUser(v: AuthUser) {
    if (!v) {
      localStorage.removeItem('authUser');
    }
    localStorage.setItem('authUser', JSON.stringify(v));
    this._authUser = v;
  }

  setMenu() {
    if (this._authUser && this._authUser.identificador && this._authUser.roles!.length) {
      this.menuService.setMenu(this._authUser.roles![0].funcionalidades!);
    }
  }

  public restore(email: string): Observable<AppResponse<string>> {
    return this.http.get<AppResponse<string>>(`${environment.url_seguridad}/Auth/restore?email=${email}`);
  }

  private forceReload() {
    // limpia caches
    if ('caches' in window) {
      caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
    }

    // recarga dura
    window.location.reload();

  }

  public clearSesion() {
    localStorage.clear();
  }
}
